<template>
    <div class="container">
        <section-header
            title="Statystyki"
            class="mt-5 mb-2 mb-lg-4"
        />

        <div v-if="statistics" class="row row-cols-1 row-cols-md-2">
            <div
                class="col mt-4"
                v-for="(statistic, idx) in statistics"
                :key="idx"
            >
                <div class="c-service is-featured">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div class="c-service-content">
                            <h2 class="c-service-heading h5 mt-0">
                                {{ statistic.heading }}
                            </h2>

                            <div class="c-service-text">
                                <p>{{ statistic.description }}</p>
                            </div>
                        </div>
                        <div class="c-service-actions">
                            <div class="c-service-buttons mt-2">
                                <button
                                    @click="goToStatisticClick(statistic)"
                                    class="btn btn-block btn-secondary"
                                >
                                    Wygeneruj raport
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Statistics',
    computed: {
        isShopUser() {
            return this.$store.getters.isShopUser
        },
        statistics() {
            return [
                {
                    heading: 'Sprzedaż sumaryczna w Twoich sklepach',
                    description: 'Ogólna liczba sprzedanych sztuk.',
                    moduleName: 'saleTrend',
                    isHidden: this.isShopUser
                },
                {
                    heading: 'Sprzedaż produktów w Twoich sklepach',
                    description: 'Top najlepiej sprzedających się produktów w Twoich sklepach.',
                    moduleName: 'topSale'
                }
            ].filter(e => !e.isHidden)
        }
    },
    methods: {
        goToStatisticClick(statistic) {
            this.$router.push({ name: statistic.moduleName })
        }
    }
}
</script>
